<template>
  <button @click="$emit('click')" class="select-button" role="button">
      {{ text }}
      <span class="figure figure--v" />
    </button>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    text: {
      type: String,
      required: true,
    },
  },
})
export default class SelectButton extends Vue {
  
}
</script>

<style lang="scss">
.select-button {
  width: 100%;
  background-color: #009FEA;
  color: #fff;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 12px;
  text-align: center;
  font-family: 'Gotham';
  font-weight: bold;
  border: 0;
  line-height: 12px;
  letter-spacing: 0;
  padding: 11px 0;

  .figure {
    display: inline-block;
    transform: rotate(-90deg);
    margin-left: 4px;

    &::before {
      font-size: 7px;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/SelectButton.vue